const SkeletonLoading = () => {
    return (
        <div className="tw:bg-[linear-gradient(180deg,#f6f6f6_0%,#ffffff_100%)] tw:pt-[152px] tw:pb-16 tw:text-[#212529] tw:font-hanken-grotesk">
            <div className="tw:px-0 tw:lg:px-[70px] tw:max-w-[1300px] tw:mx-auto">
                {/* Header Skeleton */}
                <div className="tw:mb-8 tw:flex tw:flex-col tw:gap-2 tw:px-4 tw:lg:px-0">
                    <div className="tw:h-4 tw:w-32 tw:animate-pulse tw:bg-gray-200" />
                    <div className="tw:h-8 tw:w-64 tw:animate-pulse tw:bg-gray-200" />
                </div>

                {/* Sections Skeleton */}
                {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="tw:mb-6 tw:rounded-[10px] tw:bg-white tw:p-6 tw:shadow-[0px_4px_20px_rgba(0,0,0,0.05)]">
                        <div className="tw:mb-4 tw:h-6 tw:w-48 tw:animate-pulse tw:bg-gray-200" />
                        <div className="tw:h-px tw:w-full tw:bg-gray-100 tw:mb-6" />
                        <div className="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:lg:grid-cols-3 tw:gap-6">
                            {[1, 2, 3].map((j) => (
                                <div key={j} className="tw:flex tw:flex-col tw:gap-2">
                                    <div className="tw:h-3 tw:w-24 tw:animate-pulse tw:bg-gray-200" />
                                    <div className="tw:h-10 tw:w-full tw:animate-pulse tw:bg-gray-100 tw:rounded-[5px]" />
                                </div>
                            ))}
                        </div>
                    </div>
                ))}

                {/* Action Buttons Skeleton */}
                <div className="tw:mt-8 tw:flex tw:justify-end tw:gap-4 tw:px-4 tw:lg:px-0">
                    <div className="tw:h-12 tw:w-32 tw:animate-pulse tw:bg-gray-200 tw:rounded-[5px]" />
                    <div className="tw:h-12 tw:w-32 tw:animate-pulse tw:bg-gray-200 tw:rounded-[5px]" />
                </div>
            </div>
        </div>
    );
};

export default SkeletonLoading;
